import { render, staticRenderFns } from "./editUser.vue?vue&type=template&id=b74be666&scoped=true"
import script from "./editUser.vue?vue&type=script&lang=ts"
export * from "./editUser.vue?vue&type=script&lang=ts"
import style0 from "./editUser.vue?vue&type=style&index=0&id=b74be666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74be666",
  null
  
)

export default component.exports